import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const GreenButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({ children, ...other }, ref) => {

  const lowercaseChildren = String(children).toLowerCase();

  if (lowercaseChildren.endsWith('ave & close')) { // save & close
    other.id = other.id ? other.id + '-detail-saveclose-button' : 'detail-savecontinue-button';
  } else if (lowercaseChildren.endsWith('ave')) { // save
    other.id = other.id ? other.id + '-detail-save-button' : 'detail-save-button';
  } else if (lowercaseChildren.endsWith('ave & Continue')) { // save & continue
    other.id = other.id ? other.id + '-detail-savecontinue-button' : 'detail-savecontinue-button';
  }

  return (
    <IfmsButton ref={ref} {...other} baseClass="ifms-green-button">
      {children}
    </IfmsButton>
  );
});

GreenButton.defaultProps = {
  bold : false
};

GreenButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
  bold: PropTypes.bool
};

export default React.memo(GreenButton);

